import { pxToRem } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flex: {
      display: 'flex',
      flex: '1',
      paddingLeft: theme.spacing(1),
    },
    brdBtm: {
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider,
      padding: theme.spacing(2, 0),
      pageBreakInside: 'avoid',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    labelCol: {
      width: '25%',
      marginRight: theme.spacing(3),
    },
    flexGrow: {
      flex: '1',
    },
    marginLeft: {
      margin: theme.spacing(0, 0, 0, 1),
    },
    marginBottom: {
      marginBottom: theme.spacing(1),
    },
    marginBottomLarge: {
      marginBottom: theme.spacing(2),
    },
    marginTopSmall: {
      marginTop: theme.spacing(0.5),
    },
    marginTop: {
      marginTop: theme.spacing(1),
    },
    marginTopLarge: {
      marginTop: theme.spacing(2),
    },
    typographyFontSize: {
      fontSize: '14px',
    },
    transactionMessageContainer: {
      fontSize: pxToRem(16),
      fontWeight: 600,
    },
    bold: {
      fontWeight: 'bold',
    },
    // The shared alert pins its action to the top right; this one sits inline, centered.
    underwriterAlert: {
      '& .MuiAlert-action': {
        position: 'static',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: theme.spacing(2),
      },
      '& .MuiAlert-message': {
        paddingRight: 0,
      },
    },
    // button/xSmall, inheriting the alert's own text color
    alertActionLabel: {
      fontFamily: 'Inter',
      fontSize: pxToRem(12),
      fontWeight: 600,
      lineHeight: pxToRem(22),
      letterSpacing: '0.46px',
      color: 'inherit',
    },
    alertActionButton: {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: pxToRem(14),
      letterSpacing: '0.46px',
      padding: theme.spacing(0.125, 0.625),
      minWidth: 'auto',
      color: 'inherit',
      backgroundColor: 'transparent',
      border: 'none',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    retryText: {
      color: theme.palette.error.main,
    },
    pendingTexts: {
      margin: 0,
    },
    drawerContainer: {
      flexDirection: 'column',
      paddingLeft: 0,
    },
    smallText: {
      fontSize: pxToRem(12),
      color: theme.palette.text.secondary,
      fontWeight: 400,
      padding: theme.spacing(0, 3),
    },
    drawerHeading: {
      fontSize: pxToRem(18),
      marginBottom: 0,
      padding: theme.spacing(0, 3),
    },
    drawerHeadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      borderBottom: `1px solid ${theme.palette.divider}`,
      paddingTop: theme.spacing(1),
    },
    drawerContent: {
      padding: theme.spacing(3),
      '& .radioContainer': {
        paddingTop: 0,
      },
    },
  }),
);

export default useStyles;
